<script setup lang="ts">
import { computed, ref } from "vue";

import type { I_WIDGET_STEPS } from "~/tiw/stores/tiw/tiw.types";

import Modal from "@/components/modal/modal.vue";
import NewDeviceCard from "@/components/NewDeviceCard/NewDeviceCard.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import { usePostQuestDevice } from "~/tiw/hooks/usePostQuestDevice/usePostQuestDevice";
import { useChooseDeviceStore } from "~/tiw/stores/chooseDevice/chooseDevice";

const TIWStore = useTIWStore();
const chooseDeviceStore = useChooseDeviceStore();

const MOCK_DATA = [
    {
        title: useTranslate("tiw__chooseDeviceToBuy_otherDevice"),
        imageUrl: `${import.meta.env.VITE_APP_URL}/img/abstract-device.svg`,
        id: "",
    },
];

const isLoadingToNext = ref(false);
const isNextButtonDisabled = computed(
    () =>
        isLoadingToNext.value ||
        chooseDeviceStore.isDeviceNotAccepted ||
        (!TIWStore.INJECTED_GOOD.article && TIWStore.INJECTED_GOOD.article !== ""),
);

function selectDevice(id: string) {
    TIWStore.INJECTED_GOOD.article = id;
}

async function clickToNext() {
    isLoadingToNext.value = true;
    await usePostQuestDevice();
    // TODO: полумай, что делать, если в запросе строкой выше выпадает ошибка.
    isLoadingToNext.value = false;
    const nextStep: I_WIDGET_STEPS = chooseDeviceStore.isDeviceNotAccepted
        ? "chooseDevice"
        : "howYouRateDevice";
    TIWStore.switchStep(nextStep);
}
</script>

<template>
    <Modal>
        <template #header>
            <p class="tiw__h2 tiw__h2-chooseDeviceToBuy-title">
                {{ useTranslate("tiw__chooseDeviceToBuy_title") }}
            </p>
        </template>
        <NewDeviceCard
            v-for="device of MOCK_DATA"
            :key="device.id"
            :title="device.title"
            :image-url="device.imageUrl"
            :is-selected="device.id === TIWStore.INJECTED_GOOD.article"
            :id-to-select="device.id"
            @select="selectDevice"
        />

        <Button
            type="button"
            :disabled="isNextButtonDisabled"
            :loading="isLoadingToNext"
            class="tiw__step__chooseDevice__btn-next tiw__btn-next_manual"
            @click="clickToNext"
        >
            <span>{{ useTranslate("tiw__continue") }}</span>
        </Button>
    </Modal>
</template>

<style scoped lang="scss">
.tiw__h2-chooseDeviceToBuy-title {
    text-wrap: pretty;
}
</style>
